angular.module('bb.appointments').controller('ApptWatch', apptWatch);

apptWatch.$inject = [
  '$location',
  '$scope',
  'ApptWatchService',
  '$routeParams',
  '$rootScope',
  'userService',
];
function apptWatch(
  $location,
  $scope,
  ApptWatchService,
  $routeParams,
  $rootScope,
  userService,
) {
  const { appointmentId } = $routeParams;
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.appointments = {};
  vm.usersViewing = [];

  $scope.$watch(
    function () {
      return ApptWatchService.state;
    },
    function (newVal) {
      updateAppointments(newVal);
    },
    true,
  );

  if (appointmentId) {
    ApptWatchService.subscribeAppt(appointmentId);
  }

  vm.viewAppointment = appt => {
    if (vm.appointments[appt.id] && vm.appointments[appt.id].length) {
      userService
        .getUserNames(Array.from(new Set(vm.appointments[appt.id])))
        .then(usernames => {
          const filtered = usernames.filter(name => !!name);
          const title =
            filtered.length === 0 &&
            `Someone from ${
              vm.auth.org.type === 'brokerage'
                ? 'the MLS staff / answering service'
                : 'the brokerage'
            } is already in this showing`;

          // eslint-disable-next-line no-undef
          swal(
            {
              title:
                title ||
                `${filtered.join(', ')} ${
                  filtered.length === 1 ? 'is' : 'are'
                } already in this showing`,
              type: 'warning',
              confirmButtonColor: '#f48042',
              showCancelButton: true,
              confirmButtonText: 'Enter Showing',
              cancelButtonText: 'Back to Queue',
            },
            () => {
              $rootScope.viewDashAppointment(appt);
            },
          );
        });
    } else {
      $rootScope.viewDashAppointment(appt);
    }
  };

  function updateAppointments(appts) {
    vm.appointments = appts || {};
    if (appointmentId) {
      vm.usersViewing = vm.appointments[appointmentId] || [];
      vm.usersViewing = vm.usersViewing.filter(id => id !== $rootScope.auth.id);
      vm.usersViewing = Array.from(new Set(vm.usersViewing));
      return userService.getUserNames(vm.usersViewing).then(userNames => {
        const defaultText =
          vm.auth.org.type === 'brokerage'
            ? 'MLS Staff / Answering Service User(s)'
            : 'Brokerage User(s)';
        vm.usersViewingString = userNames.join(', ') || defaultText;
      });
    }
  }

  vm.youAreViewing = function () {
    return (
      appointmentId &&
      vm.appointments[appointmentId] &&
      vm.appointments[appointmentId].filter(id => id === $rootScope.auth.id)
        .length > 1
    );
  };

  vm.isBeingViewed = function (id) {
    return !!vm.appointments[id];
  };

  $scope.$on('$destroy', function () {
    if (appointmentId) {
      ApptWatchService.unsubscribeAppt();
    }
  });

  function onAppointmentChange(_event, apptAction) {
    if (
      !apptAction ||
      !appointmentId ||
      apptAction.appointmentId !== appointmentId
    ) {
      return;
    }

    const { statusDetails, appointment } = apptAction;

    if (
      statusDetails &&
      statusDetails.userId === $rootScope.auth.id &&
      statusDetails.status === 'new'
    ) {
      return;
    }

    const isRefresh = appointment.isPending && !appointment.isDeleted;

    // eslint-disable-next-line no-undef
    swal(
      {
        title: 'Showing Has Changed',
        text: 'An action has been taken on this showing',
        type: 'warning',
        confirmButtonColor: '#f48042',
        confirmButtonText: isRefresh ? 'Refresh' : 'Return to Queue',
      },
      function () {
        if (isRefresh) {
          window.location.reload(true);
        } else {
          const path =
            vm.auth.org.type === 'brokerage'
              ? '/admin/dashboard'
              : '/answering/queue';

          $scope.$evalAsync(() => {
            $location.path(path);
          });
        }
      },
    );
  }
  $scope.$on('appointment_status', onAppointmentChange);
}

export {};
